
import { SVGProps } from 'react';

const InfoIcon = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM12.4688 7.5C12.4688 10.5203 10.0203 12.9688 7.00003 12.9688C3.97972 12.9688 1.53128 10.5203 1.53128 7.5C1.53128 4.47969 3.97972 2.03125 7.00003 2.03125C10.0203 2.03125 12.4688 4.47969 12.4688 7.5ZM7.87503 4.4375C7.87503 4.92075 7.48328 5.3125 7.00003 5.3125C6.51678 5.3125 6.12503 4.92075 6.12503 4.4375C6.12503 3.95425 6.51678 3.5625 7.00003 3.5625C7.48328 3.5625 7.87503 3.95425 7.87503 4.4375ZM6.12506 6.95733C6.12506 6.47408 6.51681 6.08233 7.00006 6.08233C7.48331 6.08233 7.87506 6.47408 7.87506 6.95733V10.5626C7.87506 11.0459 7.48331 11.4376 7.00006 11.4376C6.51681 11.4376 6.12506 11.0459 6.12506 10.5626V6.95733Z" fill="#616161" />
    </svg>
);

export default InfoIcon;
